"use strict";
export const VdGroupMock = (mock) => {
  mock.onPost("/v1/virtual-desktops-groups").reply((cofig) => {
    let _response = {};
    return [200, _response];
  });
  mock.onGet(/\/v1\/virtual-desktops\/(\d+)\/groups/).reply((config) => {
    let _response = {
      "groupIds": [
        "1818182982012702721"
      ]
    };
    return [200, _response];
  });
};
